<template>
  <div class="liftList">
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <Grid
        :ref="kgm_ref"
        :style="{height: 'auto'}"
        :data-items="kgm_computedGridItems(lifts)"
        :columns="kgm_responsiveColumns()"
        :filterable="true"
        :filter="kgm_filter"
        :pageable="kgm_pagable"
        :page-size="kgm_take"
        :skip="kgm_skip"
        :take="kgm_take"
        :total="kgm_allGridItems(lifts)"
        :sortable="{
          allowUnsort: true,
          mode: kgm_sortMode
        }"
        :sort="kgm_sort"
        selected-field="selected"
        @rowclick="kgm_gridOnRowClick"
        @filterchange="kgm_gridFilterChange"
        @pagechange="kgm_gridPageChange"
        @sortchange="kgm_gridSortChange"
      >
        <div
          slot="textFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="textFilterInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a value"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('textFilterInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <template
          slot="typeCell"
          slot-scope="{props}"
        >
          <td>
            {{ getSectionType(props.dataItem.typeId) }}
          </td>
        </template>

        <template
          slot="optionsTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <div class="btn-group">
              <button
                class="btn btn-primary btn-sm"
                @click="showSidebarEdit(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="edit"
                />
                <span>{{ $t('edit') }}</span>
              </button>
              <button
                slot="button"
                class="btn btn-danger btn-sm"
                @click="openConfirmModal(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="trash"
                />
              </button>
            </div>
          </td>
        </template>
      </Grid>
      <Sidebar
        v-if="showSidebar"
        :show-sidebar="showSidebar"
        @close="close"
      >
        <LiftAdd
          v-if="addingElement"
          :resort-id="resortId"
          :locations="locations"
          @reload="reloadLifts"
        />
        <LiftEdit
          v-else
          :section="lift"
          :locations="locations"
          @reload="reloadLifts"
        />
      </Sidebar>
      <SweetModal
        ref="confirmDelete"
        :title="$t('introOutroListComp.deleteElement')"
        icon="warning"
      >
        <p v-if="lift">
          {{ $t('sureToDelete', {'0' : lift.id}) }}
        </p>
        <button
          slot="button"
          class="btn btn-secondary float-left mb-3"
          @click="$refs.confirmDelete.close()"
        >
          <font-awesome-icon
            class="mr-2"
            icon="times"
          />{{ $t('cancel') }}
        </button>
        <button
          slot="button"
          class="btn btn-danger float-right mb-3"
          @click="removeLift()"
        >
          <font-awesome-icon
            class="mr-2"
            icon="trash"
          />{{ $t('delete') }}
        </button>
        <div class="clearfix" />
      </SweetModal>
    </template>
  </div>
</template>

<script>
import { kendoGridMixin } from '@/mixins/kendoGridMixin.js';
import Sidebar from '@/components/Base/Sidebar.vue';
import LiftAdd from '@/components/Resort/LiftAdd.vue';
import LiftEdit from '@/components/Resort/LiftEdit.vue';
import { SweetModal } from 'sweet-modal-vue';

export default {
  name: "LiftList",
  components: {
    Sidebar,
    LiftAdd,
    LiftEdit,
    SweetModal
  },
  mixins: [
    kendoGridMixin
  ],
  props: {
    resortId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      lifts: null,
      lift: null,
      addingElement: false,
      showSidebar: false,
      deleteIndex: null,
      sectionTypes: [],
      locations: [],
      kgm_columns: [
        {
          field: 'id',
          filterable: true,
          title: 'Id',
          filterCell: "textFilter"
        },
        {
          field: 'attributes.old_id',
          filterable: true,
          title: 'Old Id',
          filterCell: "textFilter"
        },
        {
          field: 'name',
          filterable: true,
          filter: 'text',
          title: 'Name',
          filterCell: "textFilter",
          hideOn: ['xsDown']
        },
        {
          field: 'startLocationId',
          filterable: true,
          title: 'C-Point Start Id',
          filterCell: "textFilter",
          hideOn: ['smDown']
        },
        {
          field: 'endLocationId',
          filterable: true,
          title: 'C-Point End Id',
          filterCell: "textFilter",
          hideOn: ['smDown']
        },
        {
          field: 'typeId',
          filterable: true,
          title: 'Type',
          hideOn: ['smDown'],
          filterCell: "textFilter",
          cell: 'typeCell'
        },
        {
          field: 'duration',
          filterable: false,
          title: 'Durtation',
          hideOn: ['smDown']
        },
        {
          field: 'length',
          filterable: false,
          title: 'Length',
          hideOn: ['smDown']
        },
        {
          filterable: false,
          title: 'Options',
          cell: 'optionsTemplate',
        }
      ]
    }
  },
  watch: {
    resortId () {
      this.getData();
    }
  },
  created () {
    this.getData();
  },
  methods: {
    getSectionType(id) {
      const found = this.sectionTypes.find(x => x.id === id)
      if (found) {
        return found.name
      }
      return ""
    },
     openConfirmModal (data) {
       this.setCurrentLift(data);
      this.deleteIndex = data.id;
      this.$refs.confirmDelete.open();
    },
    closeModal () {
      this.reloadLifts();
    },
    show () {
      this.showSidebar = true;
    },
    close () {
      this.showSidebar = false;
    },
    showSidebarAdd () {
      this.addingElement = true;
      this.show();
    },
    showSidebarEdit (emitValues) {
      this.setCurrentLift(emitValues);
      this.addingElement = false;
      this.show();
    },
    setCurrentLift (lift) {
      this.lift = JSON.parse(JSON.stringify(lift));
    },
    reloadLifts () {
      this.showSidebar = false;
      this.$emit("reloadAuditLogs");
      this.getData();
    },
    //#region API-calls
    getData () {
      this.getSectionTypes()
      this.getLocations()
      this.loading = true;
      this.axios.get(`/Resort/GetResortLifts?resortId=${ this.resortId }`)
      .then(response => {
        this.lifts = response.data;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    removeLift () {
      this.axios.delete(`/Resort/RemoveLift?id=${ this.deleteIndex }`)
      .then(() => {
        this.$snotify.success(this.$t('resortForm.removedSuccessfullyLift'));
        this.deleteIndex = null;
        this.$refs.confirmDelete.close();
        this.reloadLifts();
      })
    },
     getSectionTypes () { 
      this.axios.get(`/Resort/GetResortSectionTypes`)
      .then(response => {
        this.sectionTypes = response.data;
      });
    },
    getLocations () { 
      this.axios.get(`/Resort/GetResortLocations?resortId=${this.resortId}&includeSharedResorts=true`)
      .then(response => {
        this.locations = response.data;
      });
    },
  }
}
</script>
<style>
.liftList .k-grid table tr:hover td {
  background :rgb(219, 219, 219) !important;
  cursor: pointer !important;
}
</style>
